import { getIsMobileOrTablet } from '@office-start/device-detection-utility';
import { OfficeDotComOrigin, OfficeDotComPrvOrigin, } from '@office-start/instrumentation-types';
import { appendAndReplaceQueryParams } from '@office-start/url-parser-utility';
import { DESIGNER_MOBILE_URL, DESIGNER_URL, NEO_DESIGN_URL, } from '../constants';
import { appendPvrAndUpnAuthParams } from './appendPvrAndUpnAuthParams';
export function getFormAuthenticatedCdn(formsOptions, isNeoPage) {
    var componentContext = formsOptions.componentContext, formsConfig = formsOptions.formsConfig;
    var isScuProdPrv = componentContext.deploymentEnvironment === 'prodprv' &&
        componentContext.geoName === 'scu';
    var authenticatedUrl = appendPvrAndUpnAuthParams(formsOptions.identity, formsConfig.formsCdnPath +
        (isNeoPage
            ? NEO_DESIGN_URL
            : getIsMobileOrTablet()
                ? DESIGNER_MOBILE_URL
                : DESIGNER_URL));
    authenticatedUrl = appendAndReplaceQueryParams(authenticatedUrl, {
        origin: isScuProdPrv ? OfficeDotComPrvOrigin : OfficeDotComOrigin,
        lang: componentContext.preferredCulture,
        sessionId: componentContext.sessionId,
    }, false, true);
    return authenticatedUrl;
}
//# sourceMappingURL=getFormAuthenticatedCdn.js.map